import AsyncStorage, { captureAccountStorage } from "./accountStorage";

export const storeLocalData = async (key: string, value: any) => {
  try {
    const jsonValue = JSON.stringify(value);
    await AsyncStorage.setItem(key, jsonValue);
  } catch (e) {
    console.log("Error storing data", e);
    // saving error
  }
};

export const getLocalData = async (key: string) => {
  try {
    const value = await AsyncStorage.getItem(key);
    if (value !== null) {
      return JSON.parse(value);
    }
  } catch (e) {
    // error reading value
  }
};

export const validateNewData = async (key: string, data: any) => {
  return await getLocalData(key).then((localData) => {
    if (typeof localData === "undefined") {
      return { needsRefreshed: true, local: localData };
    }
    return {
      needsRefreshed:
        JSON.stringify(localData).length != JSON.stringify(data).length,
      localData: localData,
    };
  });
};

export const clearLocalData = async () => {
  // AsyncStorage.clear();
};

export const clearForLogout = async () => {
  const keys = await AsyncStorage.getAllKeys();
  for (var i = 0; i < keys.length; i++) {
    // await removeKey(keys[i]);
  }
};

export const resetLocalData = async () => {
  //We want to get data from api on each new session
  const keys = await AsyncStorage.getAllKeys();
  for (var i = 0; i < keys.length; i++) {
    // await removeKey(keys[i]);
  }
};

export const removeKeysOfType = async (type: string) => {
  const keys = await AsyncStorage.getAllKeys();

  for (var i = 0; i < keys.length; i++) {
    if (keys[i].startsWith(type)) {
      // removeKey(keys[i]);
    }
  }
};

export const removeKey = async (key: string) => {
  try {
    await AsyncStorage.removeItem(key);
  } catch (e) {
    // remove error
  }
};

// Unlike the general cache helpers, session-bound operations propagate failures
// so completion cannot continue after an account change or failed durable write.
export const captureStorageSession = () => {
  const storage = captureAccountStorage();
  return {
    assertAccount: storage.assertAccount,
    isCurrent: () => {
      try { storage.assertAccount(); return true; } catch { return false; }
    },
    getLocalData: async (key: string) => {
      const value = await storage.getItem(key);
      return value === null ? undefined : JSON.parse(value);
    },
    storeLocalData: (key: string, value: any) => storage.setItem(key, JSON.stringify(value)),
    removeKey: (key: string) => storage.removeItem(key),
  };
};
